export default __webpack_public_path__ + "static/media/UNIDOAndThe2030AgendaForSustainableDevelopment.8c6232d4.pdf";